<template>
  <div class="performances">
    <div class="table">
      <div class="table-header">
        <div class="table-row c:row-between-center">
          <div
            class="table-cell head-cell c:row-center"
            style="width: 15%"
          ></div>
          <div class="table-cell head-cell c:row-center" style="width: 30%">
            销售额
          </div>
          <div class="table-cell head-cell c:row-center" style="width: 30%">
            销售量
          </div>
          <div class="table-cell head-cell c:row-center" style="width: 25%">
            订单量
          </div>
        </div>
      </div>
      <div class="table-body">
        <div
          class="table-row c:row-between-center"
          v-for="(item, index) in listData"
          :key="index"
        >
          <div
            class="table-cell head-cell c:row-start-center"
            style="width: 15%"
          >
            {{ item.label }}
          </div>
          <div class="table-cell c:row-center" style="width: 30%">
            ￥{{ item.salesAmount }}
          </div>
          <div class="table-cell c:row-center" style="width: 30%">
            {{ item.salesCount }}
          </div>
          <div class="table-cell c:row-center" style="width: 25%">
            {{ item.orderCount }}
          </div>
        </div>
      </div>
    </div>
    <PerformanceTrend :role="role" />
    <CBottomPad is-tab-page />
  </div>
</template>

<script>
import { getSMStorePerformance, getRMPerformance } from "@/api";
import PerformanceTrend from "./PerformanceTrend.vue";
import { USER_ROLES } from "@/consts";
import CBottomPad from "../common/CBottomPad.vue";

export default {
  components: { PerformanceTrend, CBottomPad },
  props: {
    role: String,
  },
  data() {
    return {
      conversion: {
        today: "今日",
        yesterday: "昨日",
        week: "本周",
        month: "本月",
      },
      properties: [],
      listData: [],
    };
  },
  watch: {
    role: {
      handler(role) {
        if (role) {
          if (role === USER_ROLES.STORE_MANAGER) {
            const storeId = this.$store.getters.currentStore?.storeId;
            if (storeId) {
              this.properties = [
                { key: "today", label: "今日" },
                { key: "yesterday", label: "昨日" },
                { key: "thisWeek", label: "本周" },
                { key: "thisMonth", label: "本月" },
                { key: "thisYear", label: "本年" },
              ];
              this.api = getSMStorePerformance.bind(null, storeId);
            } else return;
          } else {
            this.properties = [
              { key: "thisWeek", label: "本周" },
              { key: "thisMonth", label: "本月" },
              { key: "lastMonth", label: "上月" },
            ];
            this.api = getRMPerformance;
          }
          this.getData();
        }
      },
      immediate: true,
    },
  },
  methods: {
    async getData() {
      try {
        const res = await this.api();
        console.log("res", res);
        this.listData = this.properties.map((property) => ({
          ...property,
          ...(res?.[property.key] || {
            salesAmount: 0,
            salesCount: 0,
            orderCount: 0,
          }),
        }));
      } catch (error) {
        console.log("error", error);
        this.listData = this.properties.map((property) => ({
          ...property,
          salesAmount: 0,
          salesCount: 0,
          orderCount: 0,
        }));
      }
    },
  },
};
</script>

<style lang="less" scoped>
.performances {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-top: solid 1px #f2f2f2;
  padding-top: 4/20rem;
  overflow-x: hidden;
  overflow-y: auto;

  .table {
    width: 100%;

    background: #fff;

    &-header,
    &-body {
      padding: 0 14/20rem;
    }

    &-row {
      height: 44/20rem;
      border-bottom: 1/20rem solid #f1f1f1;

      &:last-child {
        border-bottom: none;
      }
    }

    &-cell {
      height: 100%;
      box-sizing: border-box;
      padding: 5/20rem;
      line-height: 17/20rem;
      font-weight: 400;
      font-size: 12/20rem;
      letter-spacing: 0;
      color: #333;
      text-align: center;

      &.head-cell {
        font-weight: 500;
      }
    }

    &-header {
      border-bottom: 1/20rem solid #f1f1f1;
      .table-row {
        height: 40/20rem;
        border-bottom: none;
      }
    }
    &-body {
      .table-cell.head-cell {
        text-align: left;
      }
    }
  }

  .chart {
    margin-top: 5/20rem;
    margin-bottom: 5/20rem;
    background: #fff;

    box-sizing: border-box;

    &-header {
      height: 40/20rem;
      padding: 0 15/20rem;
      border-bottom: 1/20rem solid #f1f1f1;

      line-height: 40/20rem;
      font-weight: 500;
      font-size: 12/20rem;
      letter-spacing: 0;
      color: #333;
    }
    &-diagram {
      padding-top: 20/40rem;
    }
  }
}
</style>
